export enum QueryErrorMessages {
  NoAppsFoundError = 'No Apps retrieved while generateCubeReport',
  ApiCallError = 'Client query failed',
  AuthException = 'Authorization error',
  RateLimitExceeded = 'Rate limit exceeded',
  QueryTopAppsReportError = 'Failed to query top apps report',
  QueryRollingAveragesReportError = 'Failed to query rolling averages report',
  QuerygetTopAppsReportError = 'Failed query getTopAppsReport',
  QueryGetAllScoresError = 'Failed query getAllScores',
  QueryAllScoresError = 'Failed query AllScores',
  QueryUserMaxScoreError = 'Failed query MaxScore',
  QueryPerWeekdayAverageAllScoresError = 'Failed query per weekday average scores',
  QueryUserAvgScoresError = 'Failed query avg scoress',
  QueryTimeSeriesError = 'Failed query time series',
  QueryHeatMapsError = 'Failed to query heat maps',
  QueryLatestTeamAppMetricsError = 'Failed to query latest team app metrics',
  QueryFilteredTeamAppMetricsError = 'Failed to query filtered team app metrics',
  QueryFilteredTeamSubscriptionMetricsError = 'Failed to query filtered team subscription metrics',
  QueryAllTimeAverageTeamAppMetricsError = 'Failed to query all time average team app metrics',
  QueryAllTimeWeekdayAverageAppDurationError = 'Failed to query all time weekday average duration',
  QueryAllTimeMaxAppMetricError = 'Failed to query all time max app metric',
  QueryTeamUserTimeSeriesAppMetricsError = 'Failed to query team user time series app metrics',
  QueryTeamAverageTimeSeriesAppMetricsError = 'Failed to query team average time series app metrics',
  QueryTeamTimeSeriesAppMetricsError = 'Failed to query team time series app metrics',
  QueryTeamAllTimeSeriesAppMetricsError = 'Failed to query team all-time time series app metrics',
  QueryGetGoalSummary = 'Failed to get goal summary, value and progress',
  QueryGetAppAveragesError = 'Failed to query app averages',
  QueryGetScoreAveragesError = 'Failed to query score averages',
}
